package game.entity

import com.soywiz.kds.iterators.fastForEach
import com.soywiz.kds.iterators.fastForEachWithIndex
import game.Game
import game.Room
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin

class TentacleBit(val spriteId: String) : Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.player.takeDamage(1)

        return false
    }
}

class Tentacle(
) : Entity() {
    private var step = 0
    private var startAngle = 0.0
    private var endAngle = 0.0
    private var currentAngle = 0.0
    private var length = 0.0

    val bits = arrayOf(
        TentacleBit("tentacle-1"),
        TentacleBit("tentacle-2"),
        TentacleBit("tentacle-2"),
        TentacleBit("tentacle-2"),
        TentacleBit("tentacle-3"),
    )

    override fun onInit(game: Game, room: Room) {
        bits.fastForEach {
            it.col = col
            it.row = row
            room.addEntity(it)
        }
    }

    override fun onRemove(game: Game, room: Room) {
        bits.fastForEach {
            room.removeEntity(it)
        }
    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                length += 0.05
                if (length >= 1.0) {
                    length = 1.0
                    step++
                }
            }
            1 -> {
                currentAngle += 0.1

                if (currentAngle >= endAngle) {
                    currentAngle = endAngle
                    step++
                }
            }
            2 -> {
                length -= 0.05
                if (length <= 0.0) {
                    length = 0.0
                    step++
                }
            }
            3 -> {
                room.removeEntity(this)
            }
        }

        val c = cos(currentAngle)
        val s = sin(currentAngle)

        bits.fastForEachWithIndex { index, it ->
            // Add 0.5 so it rotates from the 'center' of the character
            it.col = (col + index * c * length + 0.5).toInt()
            it.row = (row + index * s * length + 0.5).toInt()
        }
    }

    fun startAttack(startAngle: Double = 0.0, endAngle: Double = PI) {
        step = 0
        this.startAngle = startAngle
        this.endAngle = endAngle
        this.currentAngle = startAngle

        length = 0.0
    }
}